// const regionStorageKey = "swan-region-os";
// const regionClasses = [
//   "region-other__OS",
//   "region-us__OS",
//   "region-eu__OS",
//   "region-gb__OS",
// ];
// const euCountries = [
//   "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE",
//   "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT",
//   "RO", "SK", "SI", "ES", "SE",
// ];

// const applyRegionClass = (regionClass) => {
//   regionClasses.forEach((className) => {
//     document.body.classList.remove(className);
//   });

//   document.body.classList.add(regionClass || "region-other__OS");
// };

// const resolveRegionClass = (countryCode) => {
//   if (countryCode === "US") {
//     return "region-us__OS";
//   }

//   if (countryCode === "GB") {
//     return "region-gb__OS";
//   }

//   if (euCountries.includes(countryCode)) {
//     return "region-eu__OS";
//   }

//   return "region-other__OS";
// };

// const scheduleRegionLookup = (callback) => {
//   if (window.SwanPerf && typeof window.SwanPerf.afterInteraction === "function") {
//     window.SwanPerf.afterInteraction(callback);
//     return;
//   }

//   window.addEventListener(
//     "load",
//     function () {
//       window.setTimeout(callback, 2000);
//     },
//     { once: true }
//   );
// };

// const ipCheckRun = () => {
//   const cachedRegion = sessionStorage.getItem(regionStorageKey);

//   applyRegionClass(cachedRegion || "region-other__OS");

//   scheduleRegionLookup(function () {
//     fetch("https://ipapi.co/json/")
//       .then(function (response) {
//         return response.json();
//       })
//       .then(function (data) {
//         const regionClass = resolveRegionClass(data.country_code);

//         sessionStorage.setItem(regionStorageKey, regionClass);
//         applyRegionClass(regionClass);
//       })
//       .catch(function () {
//         fetch("https://freeipapi.com/api/json/")
//           .then(function (response) {
//             return response.json();
//           })
//           .then(function (data) {
//             const regionClass = resolveRegionClass(data.countryCode);

//             sessionStorage.setItem(regionStorageKey, regionClass);
//             applyRegionClass(regionClass);
//           })
//           .catch(function () {
//             applyRegionClass("region-other__OS");
//           });
//       });
//   });
// };

// ipCheckRun();

var $ = typeof window.jQuery === "function" ? window.jQuery : window.$;

$(document).ready(function () {


  if ($(".split-product-os")) {
    var swiperSplitProductOs = new Swiper(
      ".split-product-os .split-product-os__product-list",
      {
        slideToClickedSlide: true,
        grabCursor: true,
        loop: false,
        spaceBetween: 8,
        breakpoints: {
          320: {
            slidesPerView: 1.33,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
        },
      }
    );
    var swiperSplitProductOsDiplomat = new Swiper(
      ".template-collection.template__name_the-diplomat .split-product-os .split-product-os__product-list",
      {
        slideToClickedSlide: true,
        grabCursor: true,
        loop: false,
        spaceBetween: 8,
        breakpoints: {
          320: {
            slidesPerView: 1.39,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
        },
      }
    );
  }


  if ($(".video-popup-os")) {
    $(".video-popup-os__button, .video-popup-os__image-container").on(
      "click",
      function () {
        $(".video-popup-os__popup-container").addClass(
          "video-popup-os__popup-container--open"
        );

        $(".video-popup-os__popup-container video").trigger("play");
      }
    );

    $(".video-popup-os__popup-container__button").on("click", function () {
      $(".video-popup-os__popup-container video").trigger("pause");

      $(".video-popup-os__popup-container").removeClass(
        "video-popup-os__popup-container--open"
      );
    });
  }

  if ($(".video-text-section").length) {
    const $video = $(".video-text-section video");
    const $fallbackImage = $(".video-text-section img");

    $video[0]
      .play()
      .then(function () {
        console.log("video played");
        $fallbackImage.hide();
        $video.show();
      })
      .catch(function () {
        console.log("video error");
        $video.hide();
        $fallbackImage.show();
      });
  }

  // if ($(".hero-section").length) {
  //   const $video = $(".hero-section video");
  //   const $fallbackImage = $(".hero-section img");

  //   $video[0]
  //     .play()
  //     .then(function () {
  //       console.log("video played");
  //       $fallbackImage.hide();
  //       $video.show();
  //     })
  //     .catch(function () {
  //       console.log("video error");
  //       $video.hide();
  //       $fallbackImage.show();
  //     });
  // }

  $(document).on("click", 'a[href^="#"]:not([data-smooth-scroll])', function (event) {
    event.preventDefault();

    $("html, body").animate(
      {
        scrollTop: $($.attr(this, "href")).offset().top - 59,
      },
      500
    );
  });

  if ($(".product-sticky-form__nav").length) {
    const $navItems = $(".product-sticky-form__nav__item");
    const $indicator = $(".product-sticky-form__nav__active-indicator");
    const $nav = $(".product-sticky-form__nav ul");

    function updateIndicator() {
      const $activeItem = $navItems.filter(
        ".product-sticky-form__nav__item--active"
      );
      if ($activeItem.length) {
        const itemWidth = $activeItem.outerWidth();
        const itemLeft = $activeItem.position().left;

        // Update indicator position and width
        $indicator.css({
          width: itemWidth,
          transform: `translateX(${itemLeft}px)`,
        });

        // Scroll active item into view
        $activeItem[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    }

    function updateIndicatorWithoutScroll() {
      const $activeItem = $navItems.filter(
        ".product-sticky-form__nav__item--active"
      );
      if ($activeItem.length) {
        const itemWidth = $activeItem.outerWidth();
        const itemLeft = $activeItem.position().left;

        // Update indicator position and width
        $indicator.css({
          width: itemWidth,
          transform: `translateX(${itemLeft}px)`,
        });

        // Scroll active item into view
        // $activeItem[0].scrollIntoView({
        //   behavior: "smooth",
        //   block: "nearest",
        //   inline: "center",
        // });
      }
    }

    $(window).on("scroll", function () {
      const scrollPosition = $(window).scrollTop();

      $navItems.each(function () {
        const targetId = $(this).attr("href");
        const $target = $(targetId);

        if ($target.length) {
          const targetPosition = $target.offset().top;
          const targetHeight = $target.outerHeight();

          if (
            scrollPosition >= targetPosition - 75 &&
            scrollPosition < targetPosition + targetHeight + 70
          ) {
            $navItems.removeClass("product-sticky-form__nav__item--active");
            $(this).addClass("product-sticky-form__nav__item--active");

            // Adjust the indicator width and position
            updateIndicator();
          }
        }
      });
    });

    $nav.on("scroll", function () {
      console.log("nav scroll");
      // Disable transition
      $indicator.css("transition", "none");

      // Update indicator position and width
      updateIndicatorWithoutScroll();

      // Force reflow to apply the changes immediately
      $indicator[0].offsetHeight;

      // Re-enable transition
      $indicator.css("transition", "");
    });
  }

  if ($(".rotating-list-image").length) {
    const rotatingList = document.querySelector(".rotating-list-image");

    const rotatingListItems = rotatingList.querySelectorAll(
      ".rotating-list-image-block"
    );

    rotatingListItems[0].classList.add("rotating-list-image-block--active");

    rotatingListItems.forEach((item, i) => {
      item.addEventListener("animationend", function () {
        if (!rotatingListItems[i + 1]) return;

        item.classList.remove("rotating-list-image-block--active");
        rotatingListItems[i + 1].classList.add(
          "rotating-list-image-block--active"
        );
      });

      item.addEventListener("click", function () {
        rotatingListItems.forEach((item) => {
          item.classList.remove("rotating-list-image-block--active");
        });

        item.classList.add("rotating-list-image-block--active");
      });
    });
  }

  if ($(".review-videos").length) {
    const swiper = new Swiper(".review-videos__blocks", {
      slideToClickedSlide: true,
      grabCursor: true,
      loop: false,
      slidesPerView: 1.25,
      spaceBetween: 8,
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
      },
    });

    const blocks = Array.from(
      document.querySelectorAll(".review-video-block[data-video-url]")
    );
    const popup = document.querySelector(".review-videos__popup");
    const popupVideo = popup ? popup.querySelector("video") : null;
    const popupClose = popup ? popup.querySelector(
      ".review-videos__popup__close-button"
    ) : null;
    const nextButton = document.querySelector(
      ".review-videos__popup__next-button"
    );
    const prevButton = document.querySelector(
      ".review-videos__popup__prev-button"
    );

    if (popup && popupVideo && popupClose && blocks.length) {
      const hasMultipleVideos = blocks.length > 1;

      if (nextButton) {
        nextButton.hidden = !hasMultipleVideos;
      }

      if (prevButton) {
        prevButton.hidden = !hasMultipleVideos;
      }

      const popupCloseAction = () => {
        popupVideo.pause();
        popupVideo.setAttribute("src", "");
        popup.classList.remove("review-videos__popup--open");
      };

      blocks.forEach((block) => {
        block.addEventListener("click", function () {
          const videoSrc = block.dataset.videoUrl;

          if (!videoSrc) {
            return;
          }

          popupVideo.setAttribute("src", videoSrc);
          popup.classList.add("review-videos__popup--open");

          popup.addEventListener(
            "click",
            function (e) {
              if (e.target !== popup) {
                return;
              }

              popupCloseAction();
            },
            { once: true }
          );
          popupVideo.play();
        });
      });

      popupClose.addEventListener("click", function () {
        popupCloseAction();
      });

      const animateVideoTransition = (newVideoSrc) => {
        popupVideo.classList.add("review-videos__popup--fade-out");
        popupVideo.addEventListener(
          "transitionend",
          function () {
            popupVideo.setAttribute("src", newVideoSrc);
            popupVideo.classList.remove("review-videos__popup--fade-out");
            popupVideo.play();
          },
          { once: true }
        );
      };

      const popupVideoNext = () => {
        const currentVideo = popupVideo.getAttribute("src");
        let nextVideo = null;

        blocks.forEach((block, index) => {
          if (block.dataset.videoUrl === currentVideo) {
            const nextIndex = (index + 1) % blocks.length;
            nextVideo = blocks[nextIndex].dataset.videoUrl;
          }
        });

        if (nextVideo) {
          animateVideoTransition(nextVideo);
        }
      };

      const popupVideoPrev = () => {
        const currentVideo = popupVideo.getAttribute("src");
        let prevVideo = null;

        blocks.forEach((block, index) => {
          if (block.dataset.videoUrl === currentVideo) {
            const prevIndex = (index - 1 + blocks.length) % blocks.length;
            prevVideo = blocks[prevIndex].dataset.videoUrl;
          }
        });

        if (prevVideo) {
          animateVideoTransition(prevVideo);
        }
      };

      if (nextButton) {
        nextButton.addEventListener("click", function () {
          popupVideoNext();
        });
      }

      if (prevButton) {
        prevButton.addEventListener("click", function () {
          popupVideoPrev();
        });
      }
    }
  }
});




document.querySelectorAll(".video-section-OS").forEach((section) => {
  const video = section.querySelector("video");
  const textСontainer = section.querySelector(".video-section-section__text-container");
  const playButtons = section.querySelectorAll(".video-section-OS__image-container__button");

  if (!video) {
    playButtons.forEach(playButton => {
      playButton.style.opacity = 0;
    });
  }
  if (!video) return;

  playButtons.forEach(playButton => {
    playButton.addEventListener("click", () => {
      section.classList.add("video-section-OS--playing");
      video.play();
      video.style.display = "block";
      textСontainer.style.display = "none";
    });
  });

  video.addEventListener("ended", () => {
    section.classList.remove("video-section-OS--playing");
  });
});